// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2Ucca","vLegacy":"SelectSecondary_vLegacy__3Bzqa","error":"SelectSecondary_error__ZOtW6","disabled":"SelectSecondary_disabled__gbKt3"};